import bannerImg from './banners/woman-helping-man-gym.jpg';

const leadDesafio30Dias = (t) => ({
    id: 'lead-desafio-30-dias',
    title: t('templates.items.leadDesafio30Dias.title'),
    description: t('templates.items.leadDesafio30Dias.description'),
    indicatedFor: t('templates.audiences.personalTrainers'),
    stepsCount: 1,
    questionsSummary: [
        t('templates.items.leadDesafio30Dias.summary.nameAndContact'),
        t('templates.items.leadDesafio30Dias.summary.challengeGoal'),
        t('templates.items.leadDesafio30Dias.summary.trainingExperience'),
        t('templates.items.leadDesafio30Dias.summary.rulesAgreement'),
    ],
    banner: `url(${bannerImg}) center / cover no-repeat`,
    formData: {
        title: t('templates.items.leadDesafio30Dias.form.title'),
        active: false,
        allow_multiple_answers: false,
        theme: 'light',
        steps: [
            {
                order: 1,
                title: t('templates.items.leadDesafio30Dias.form.signup.title'),
                description: null,
                header: null,
                submitAction: 'next_step',
                submitButtonText: t('templates.items.leadDesafio30Dias.form.signup.submit'),
                allowReturn: false,
                submitLink: null,
                questions: [
                    {
                        order: 1,
                        type: 'full_name',
                        label: t('templates.items.leadDesafio30Dias.form.signup.fullName.label'),
                        description: null,
                        required: true,
                        settings: null,
                    },
                    {
                        order: 2,
                        type: 'email',
                        label: t('templates.items.leadDesafio30Dias.form.signup.email.label'),
                        description: null,
                        required: true,
                        settings: null,
                    },
                    {
                        order: 3,
                        type: 'phone',
                        label: t('templates.items.leadDesafio30Dias.form.signup.whatsapp.label'),
                        description: null,
                        required: true,
                        settings: null,
                    },
                    {
                        order: 4,
                        type: 'text',
                        label: t('templates.items.leadDesafio30Dias.form.signup.expectation.label'),
                        description: null,
                        required: true,
                        settings: null,
                    },
                    {
                        order: 5,
                        type: 'scale',
                        label: t('templates.items.leadDesafio30Dias.form.signup.experience.label'),
                        description: null,
                        required: true,
                        settings: {
                            min: 1,
                            max: 5,
                            minLabel: t('templates.items.leadDesafio30Dias.form.signup.experience.minLabel'),
                            maxLabel: t('templates.items.leadDesafio30Dias.form.signup.experience.maxLabel'),
                            dotConfigs: [
                                { iconKey: 'star' },
                                { iconKey: 'star' },
                                { iconKey: 'star' },
                                { iconKey: 'star' },
                                { iconKey: 'star' },
                            ],
                        },
                    },
                    {
                        order: 6,
                        type: 'yes_no_maybe',
                        label: t('templates.items.leadDesafio30Dias.form.signup.commitment.label'),
                        description: null,
                        required: true,
                        settings: null,
                    },
                ],
            },
        ],
        actions: [],
    },
});

export default leadDesafio30Dias;
